// extracted by mini-css-extract-plugin
export default {"wixStudioToolBar":"ZAZYq4","logo":"rWQeek","switcher":"k4KVG4"};